import React from "react";
import {
  Box,
  Step,
  StepLabel,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import { McInput } from "@maersk-global/mds-react-wrapper/mc-input";
import apiClient from "../api/apiClient";
import { format,toZonedTime } from "date-fns-tz"; 
import { apiUrl } from "../authconfig";
const steps = [
  {
    title: "Complete Onboarding Lite",
    checkpoints: [
      { name: "The Internal systems are ready to receive the first booking", key: "intrnlSysRdyRcvFrstBkgLite" },
      { name: "A call made to the customer to share Maersk contact ,how to use Maersk standard systems and identify if any special needs", key: "quikCalToCusShrCntctLite" },
      { name: "The first booking is received", key: "frstBookingRcvdLite" },
    ],
  },

];


const CustomerOnboardingLite = (props) => {

    const currentUser = JSON.parse(sessionStorage.getItem("user"));
  const handleChange = (e, checkpoint) => {
    //console.log('step',e.target.checked,checkpoint)
    props.setProjectPhaseData({
      ...props.projectPhaseData,
      [checkpoint.key]: e.target.checked,
    });
  };

    const handleClosePhase = async (e,name) => {
    const todayDate = new Date();
    const todayOnly = new Date(
      todayDate.getFullYear(),
      todayDate.getMonth(),
      todayDate.getDate()
    );
    const actualGoLiveDateOnly = props.projectPhaseData?.actualGoLiveDate
      ? new Date(props.projectPhaseData.actualGoLiveDate)
      : null;

    if (
      actualGoLiveDateOnly &&
      !Number.isNaN(actualGoLiveDateOnly.getTime()) &&
      new Date(
        actualGoLiveDateOnly.getFullYear(),
        actualGoLiveDateOnly.getMonth(),
        actualGoLiveDateOnly.getDate()
      ) > todayOnly
    ) {
      alert("Actual Go-Live Date cannot be a future date.");
      return;
    }

    if (!String(props.projectPhaseData?.firstBookingReference || "").trim()) {
      alert("1st booking reference number is required before you can close the project.");
      return;
    }

    const hasActualGoLiveDate = Boolean(props.projectPhaseData?.actualGoLiveDate);
        const hasContactingSalesSelection =
          typeof props.projectPhaseData?.contactingSales === "boolean";
        const isContactingSalesYes = props.projectPhaseData?.contactingSales === true;

        if (!hasActualGoLiveDate) {
          alert(
            "Actual go-live date is required before project closure."
          );
          return;
        }

        if (!hasContactingSalesSelection) {
          alert("Please select whether this project involves contacting Sales for participation.");
          return;
        }

        if (
          isContactingSalesYes &&
          !String(props.projectPhaseData?.reasonForSalesParticipation || "").trim()
        ) {
          alert("Reason for sales participation is required when contacting Sales is Yes.");
          return;
        }

        if (
          isContactingSalesYes &&
          props.projectPhaseData?.reasonForSalesParticipation === "Others" &&
          !String(props.projectPhaseData?.reasonForSalesOther || "").trim()
        ) {
          alert("Please provide details for 'Others' under reason for sales participation.");
          return;
        }

        const agreementStartDate = props.projectPhaseData?.agreementStartDate
          ? new Date(props.projectPhaseData.agreementStartDate)
          : null;
        const isProjectGoLiveDelayedReasonRequired =
          agreementStartDate &&
          actualGoLiveDateOnly &&
          !Number.isNaN(agreementStartDate.getTime()) &&
          !Number.isNaN(actualGoLiveDateOnly.getTime()) &&
          Math.floor(
            (actualGoLiveDateOnly - agreementStartDate) / (1000 * 60 * 60 * 24)
          ) > 15;

        if (
          isProjectGoLiveDelayedReasonRequired &&
          !String(props.projectPhaseData?.projectGoLiveDelayedReason || "").trim()
        ) {
          alert(
            "Project go-live delayed reason is required when Actual Go-Live Date is more than 15 days after Agreement Start Date."
          );
          return;
        }

        if (
          !(
            props.projectPhaseData?.estimatedGoLiveDate &&
            props.projectPhaseData?.estimatedHypercareEndDate
          )
        ) {
          alert("Please fill the estimated Golive Date and Estimated Hypercare end date");
          return;
        }

        if (window.confirm("Are you sure you want to close this phase?") == true) {
         await props.setProjectPhaseData({ ...props.projectPhaseData, [name]: true });
   
            apiClient.post(`${apiUrl}/api/opportunities/save`, { ...props.projectPhaseData, [name]: true,modifiedBy:currentUser?.mail, modifiedDate: format(toZonedTime(new Date(), "Europe/Copenhagen"), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
              liteOnboarding:true, fullOnboarding:false, projectPhase:name == 'closePhaseLite' ? "Close Project" : ''})
      .then((response) => {
          console.log(response); 
          alert("Phase Closed Successfully") 
            }).catch((error) => {
                alert(error.response.data || "Something went wrong");
              console.log(error);
            })
          }
          
        
      };

    const handleCommentChange = (e, key) => {
        props.setProjectPhaseData({
          ...props.projectPhaseData,
          [key]: e.target.value,
        });
      };
  return (
    <div>
      <Box sx={{ width: "100%", padding: 2, fontSize: "14px" }}>
              {steps.map((step, stepIndex) => (
                <Step key={stepIndex}>
                  <StepLabel>
                    <div style={{ fontSize: "14px" }}>{step.title}</div>
                  </StepLabel>
                  <Box sx={{ paddingLeft: 4 }}>
                    {step.checkpoints.map((checkpoint, checkpointIndex) => (
                      <FormControlLabel
                        key={checkpointIndex}
                        sx={{ fontSize: "14px" }}
                        control={
                          <Checkbox
                            checked={
                              props.projectPhaseData
                                ? props.projectPhaseData[checkpoint["key"]]
                                : false
                            }
                            disabled={
                          
                              props.projectPhaseData && ((props.projectPhaseData?.closePhaseLite ) || props.currentModalData?.projectStatus == "Cancelled" || props.currentModalData?.projectStatus == "Not in Current Scope" || props.currentModalData?.assignedUser != currentUser?.mail)
                             }
                            onChange={(e) => handleChange(e, checkpoint)}
                          />
                        }
                        label={
                          <Typography sx={{ fontSize: "14px" }}>
                            {checkpoint.name}
                          </Typography>
                        }
                      />
                    ))}
                    <div
                      style={{
                        fontSize: "14px",
                        color: "black",
                        fontWeight: "normal",
                        marginBottom: "10px",
                      }}
                    >
                      Comments
                    </div>
                    <textarea
                      style={{ display: "flex", width: "calc(100% - 32px)" }}
                      rows={2}
                      value={
                       ( props.projectPhaseData
                          ? props.projectPhaseData?.phaseLiteComments
                          : "") || ""
                      }
                    //   disabled={
                          
                    //     props.projectPhaseData && (props.projectPhaseData?.phaseLiteComments)
                    //    }
                    disabled={props.currentModalData?.projectStatus == "Cancelled" || props.currentModalData?.projectStatus == "Not in Current Scope" || props.currentModalData?.projectStatus == "Complete" || props.currentModalData?.assignedUser != currentUser?.mail}
                      onChange={(e) =>
                        handleCommentChange(e, `phaseLiteComments`)
                      }
                    />
                    <Box sx={{ display: "flex", gap: 1, marginTop: 1 }}>
                      <Button
                      className="closePhaseButton"
                        style={{
                          padding: "0 10px",
                          width: "max-content",
                          backgroundColor: "rgb(0, 36, 61)",
                          color: "#fff",
                        }}
                        variant="outlined"
                        color="primary"
                        disabled={
                          
                            props.projectPhaseData && ( props.projectPhaseData?.projectStatus != 'Complete' || props.projectPhaseData?.closePhaseLite)
                        }
                        onClick={(e) =>
                          handleClosePhase(e,`closePhaseLite`)
                        }
                      >
                        Close Project
                      </Button>
                    </Box>
                  </Box>
                </Step>
              ))}
          </Box>
    </div>
  )
}

export default CustomerOnboardingLite
